import type SecondaryReadingPaneTabData from './SecondaryReadingPaneTabData';

export enum TabType {
    Primary,
    OverflowMenu,
    SecondaryReadingPane,
    MailCompose,
    SxS,
    CalendarCompose,
    CalendarReadingPane,
}

export const enum TabState {
    Hidden,
    Minimized,
    Active,
    Popout,
}

export interface TabViewStateBase {
    id: string;
    state: TabState;
    startTime?: number;
    parentTabId?: string;
    blink: boolean;
    sxsId: string;
    /**
     * When opening a new compose tab, the ribbon should be "Message" by default.
     * When selecting a pre-existing compose tab, the ribbon tab shouldn't change.
     * When creating a new compose tab, firstRibbonRenderCompleted should be set to false
     * After the first ribbon render of a new compose tab, the firstRibbonRenderCompleted should be set to true.
     */
    firstRibbonRenderCompleted?: boolean;
}

export interface PrimaryReadingPaneTabViewState extends TabViewStateBase {
    type: TabType.Primary;
}

export interface SecondaryReadingPaneTabViewState extends TabViewStateBase {
    type: TabType.SecondaryReadingPane;
    data: SecondaryReadingPaneTabData;
}

export interface OverflowTabViewState extends TabViewStateBase {
    type: TabType.OverflowMenu;
    data: TabViewState[];
}

export interface CalendarComposeTabViewState extends TabViewStateBase {
    type: TabType.CalendarCompose;
    data: string /* formId */;
}

export interface CalendarReadingPaneTabViewState extends TabViewStateBase {
    type: TabType.CalendarReadingPane;
    data: string /* formId */;
}

export interface MailComposeTabViewState extends TabViewStateBase {
    type: TabType.MailCompose;
    data: string /* composeId */;
    /**
     * Tab Id of parent projection item reading pane.
     * When specified, it can only be used as inline compose for the given item reading pane tab.
     * All other reading pane tabs (conversation RP, item RP with other tab id) will ignore it.
     */
    projectionRPTabId: string;
}

export interface SxSTabViewState extends TabViewStateBase {
    type: TabType.SxS;
}

type TabViewState =
    | PrimaryReadingPaneTabViewState
    | SecondaryReadingPaneTabViewState
    | OverflowTabViewState
    | MailComposeTabViewState
    | SxSTabViewState
    | CalendarComposeTabViewState
    | CalendarReadingPaneTabViewState;

export default TabViewState;
